import React, { useState } from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import { IoLockClosedOutline, IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { FaRegEnvelope } from "react-icons/fa";
import { useNavigate, Link } from "react-router-dom";
import { TbArrowBackUp } from "react-icons/tb";
import { handleErrors } from "../../modules/handleErrors";
import apiClient from "../../api/apiClient";
import { login } from "../../redux/authSlice";
import { useDispatch } from "react-redux";
import { useIndexPageData } from "../../contextapi/Indexpagedata";
import { toast } from "react-toastify";
import GoogleSocialLogin from "../../components/Goooglelogin";
import { hasPendingCartItems } from "../../utils/pendingCart";

const Login = ({ setFormToShow, modalClose, stayOnPage = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profiledata, fetchDataprofile } = useIndexPageData();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginFromData, setLoginFromData] = useState({
    password: "",
    username: "",
  });

  const handleOnchanger = (key, value) => {
    setLoginFromData((pre) => ({ ...pre, [key]: value }));
  };

  const handlelogin = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      const response = await apiClient.post("/login/", loginFromData);
      setLoader(false);
      if (!response.ok) return handleErrors(response.data);
      toast.success("login successfully");
      fetchDataprofile(response?.data?.user_id);
      dispatch(
        login({
          token: response.data?.token,
          userType: response?.data?.role,
          role: response?.data?.role,
          userid: response?.data?.user_id,
        })
      );

      if (response?.data?.role == "A") {
        if (!stayOnPage) navigate("/admin/dashboard");
      } else if (response?.data?.role === "F") {
        if (!stayOnPage) navigate("/affiliate/dashboard");
      } else if (!stayOnPage) {
        navigate(hasPendingCartItems() ? "/cart" : "/");
      }

      modalClose();
    } catch (error) {}
  };

  const handleForget = async () => {
    const response = await apiClient.post(
      `/reset-password/{uid}/{token}/`,
      loginFromData
    );
  };

  return (
    <>
      <section className="py-3 w-100">
        <div
          className="container overflow-hidden  mb-radius"
          style={{
            backgroundColor: "#FDFAF2",
            borderTopRightRadius: "125px",
            borderBottomLeftRadius: "125px",
          }}
        >
          <div className="row  ">
            <div className="col-md-6 position-relative   p-0 ">
              <TbArrowBackUp
                className="position-absolute rounded-5 p-1  bg-white back-arrow"
                style={{
                  top: "26px",
                  left: "13px",
                  fontSize: "30px",
                  color: "#000",
                  cursor: "pointer",
                }}
                onClick={modalClose}
              />
              <div className="h-100">
                <img
                  src="../assets/images/login-img.png"
                  alt="Image"
                  className="img-fluid object-fit-cover w-100 d-none d-md-block  h-100"
                  style={{ borderTopRightRadius: "100px" }}
                />
              </div>
            </div>
            <div className="col-lg-6 py-md-0 py-3 d-flex align-items-center col-xl-6 col-md-6 justify-content-center text-center">
              <div
                className="affiliate-form  mt-3 mt-xl-5 mb-xl-4 mb-3 pe-md-3"
                style={{ maxWidth: "300px" }}
              >
                <div className="mb-2 w-75 mx-auto">
                  <Link
                    to="/"
                    onClick={() => modalClose?.()}
                    className="d-inline-block"
                    aria-label="Go to Mockee home"
                  >
                    <img
                      src="../assets/images/mockee-icon.png"
                      alt="Mockee"
                      className="m-auto login-logo"
                    />
                  </Link>
                </div>
                <h4>Welcome to the Mockee</h4>
                <div className="text-center col-md-11 m-auto">
                  <p className=" mb-4 ">
                    Please enter your login details below or if you are first
                    time here you can{" "}
                    <Link
                      to="#"
                      onClick={() => setFormToShow("register")}
                      style={{ color: "#000" }}
                    >
                      <b>'Register'</b>
                    </Link>{" "}
                    It's Free!
                  </p>
                </div>

                <form onSubmit={handlelogin}>
                  <div className="form-group mb-3">
                    <InputGroup>
                      <InputGroup.Text
                        className="position-absolute bg-white border-0 px-2  "
                        style={{
                          zIndex: 10,
                          left: 10,
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <FaRegEnvelope style={{ color: "#868B96" }} />
                      </InputGroup.Text>
                      <FormControl
                        required
                        onChange={(e) =>
                          handleOnchanger("username", e.target.value)
                        }
                        type="email"
                        id="email"
                        placeholder="Email"
                        className="form-control rounded-5 border-0  ps-5 pe-3  py-2 shadow-sm pl-5 "
                        style={{ height: "50px", fontSize: "13px" }}
                      />
                    </InputGroup>
                  </div>
                  <div className="form-group">
                    <InputGroup className="position-relative">
                      <InputGroup.Text
                        className="position-absolute bg-white border-0 px-2  "
                        style={{
                          zIndex: 10,
                          left: 10,
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <IoLockClosedOutline style={{ color: "#868B96" }} />
                      </InputGroup.Text>
                      <FormControl
                        required
                        value={loginFromData.password}
                        onChange={(e) =>
                          handleOnchanger("password", e.target.value)
                        }
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        className="form-control rounded-5 border-0 shadow-sm ps-5 py-2 pl-5"
                        style={{
                          height: "50px",
                          fontSize: "13px",
                          paddingRight: "44px",
                        }}
                      />
                      <button
                        type="button"
                        className="position-absolute border-0 bg-transparent d-flex align-items-center justify-content-center"
                        style={{
                          zIndex: 10,
                          right: 12,
                          top: "50%",
                          transform: "translateY(-50%)",
                          padding: 0,
                          color: "#868B96",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        tabIndex={0}
                      >
                        {showPassword ? (
                          <IoEyeOffOutline size={20} />
                        ) : (
                          <IoEyeOutline size={20} />
                        )}
                      </button>
                    </InputGroup>
                  </div>
                  <div className="text-end mt-1 ">
                    <Link
                      onClick={() => modalClose()}
                      to={"/forgot-password"}
                      className=""
                      style={{ color: "#000", fontSize: "13px" }}
                    >
                      Forgot Password?
                    </Link>
                  </div>

                  <div className="text-end mt-xl-4 mt-3  d-flex justify-content-center flex-wrap  gap-2  align-items-center  ">
                    {/* <div className="form-group form-check d-flex gap-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                        style={{ fontSize: "13px", color: "#6c6c6c" }}
                      >
                        Remember Me
                      </label>
                    </div> */}
                    {/* <Link to="/user/user/my-mockups" > */}
                    <button
                      type="submit"
                      className="btn btn-primary border-0 rounded-5"
                      style={{
                        borderRadius: "8px",

                        backgroundColor: "#000",
                        padding: "8px 46px",
                        fontSize: "14px",
                      }}
                    >
                      {loader ? "Sign in..." : "Sign in"}
                    </button>
                    {/* </Link> */}
                  </div>
                </form>
                <p className="mb-0  mt-3" style={{ fontSize: "12px" }}>
                  Or sign in with
                </p>
                <div className="d-flex gap-3  justify-content-center mt-1">
                  {/* <a href="#" className="ms-2 p-0 ">
                    <img src="../assets/images/fb-icon.png" alt="" />
                  </a> */}
                  {/* <a href="#" className="p-0">
                    <img src="../assets/images/google-icon.png" alt="" />
                  </a> */}
                  <GoogleSocialLogin
                    onHide={modalClose}
                    stayOnPage={stayOnPage}
                    analyticsContext={stayOnPage ? "editor" : "standard"}
                  />
                </div>
                <div className="text-center mt-3">
                  <p className="mb-0" style={{ fontSize: "13px" }}>
                    Don't have an account?{" "}
                    <Link
                      to="#"
                      onClick={() => setFormToShow("register")}
                      style={{ color: "#000", fontSize: "13px" }}
                    >
                      Register
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
